/* MUZIKINIS ŽAIDIMAS — theme.js
   Moduliai: Settings · Cart · Drawer · Player · Gallery
             UGC · Selector · StickyBuy · Qty · OwnedToggle · MobileNav
   Be išorinių bibliotekų. Audio groja tik po vartotojo veiksmo.          */
(function () {
  'use strict';

  var CFG = { freeShippingThreshold: 5000, strings: {} };
  var cfgEl = document.getElementById('mz-settings');
  if (cfgEl) { try { CFG = Object.assign(CFG, JSON.parse(cfgEl.textContent)); } catch (e) {} }

  function money(cents) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    if (v.slice(-3) === ',00') v = v.slice(0, -3);
    return v + ' \u20AC';
  }

  var toastEl = document.getElementById('mz-toast'), toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }

  /* ---------------- Cart ---------------- */
  var Cart = window.MZCartEngine.create(CFG);

  /* ---------------- Cart drawer ---------------- */
  var Drawer = {
    node: null,
    lastFocus: null,
    init: function () {
      this.node = document.getElementById('cart-drawer');
      var self = this;
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-cart-open]')) { e.preventDefault(); self.open(); }
        if (e.target.closest('[data-cart-close]')) self.close();
      });
      document.addEventListener('keydown', function (e) {
        if(!self.node||!self.node.classList.contains('is-open'))return;
        if(e.key==='Escape'){self.close();return;}
        if(e.key==='Tab'){var nodes=Array.from(self.node.querySelectorAll('a[href],button:not([disabled]),input:not([type="hidden"]):not([disabled]),select:not([disabled]),textarea:not([disabled])')).filter(function(n){return n.getClientRects().length>0;});if(!nodes.length){e.preventDefault();return;}var first=nodes[0],last=nodes[nodes.length-1];if(e.shiftKey&&(document.activeElement===first||!self.node.contains(document.activeElement))){e.preventDefault();last.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}}

      });
      this.bind();
    },
    bind: function () {
      var self = this;

      /* V123 · CART-04, CART-05 — KREPŠELIO PUSLAPIS NEVEIKĖ.

         RASTA E2E TESTU: `/cart` puslapyje eilutė renderinasi, mygtukai
         `−`, `+` ir `Pašalinti` matomi, bet paspaudus NIEKO nevyksta.
         Patikrinta per `/cart.js`: po `+` kiekis liko 1, po `Pašalinti`
         prekė liko krepšelyje.

         Priežastis: listeneriai buvo kabinami TIK ant
         `document.getElementById('cart-drawer')` vaikų. Krepšelio
         puslapio eilutės gyvena `.cartpage` bloke, UŽ drawer'io ribų,
         todėl jos neturėjo jokio listenerio.

         Sprendimas — delegavimas ant `document`. Vienas kelias abiem
         kontekstams; drawer'is atnaujinamas be perkrovimo, o krepšelio
         puslapis perkraunamas, nes jame keičiasi ir sumos, ir upsell,
         ir nemokamo pristatymo juosta.

         `_mzBusy` saugo nuo dvigubo paspaudimo, kol užklausa skrieja. */
      if (!document._mzLineDelegated) {
        document._mzLineDelegated = true;
        document.addEventListener('click', function(e){
          var button=e.target.closest('[data-line-change]');
          if(!button || document._mzLineBusy)return;
          e.preventDefault();document._mzLineBusy=true;checkoutLock(1);
          document.querySelectorAll('[data-line-change]').forEach(function(n){n.disabled=true;});
          var inDrawer=!!button.closest('#cart-drawer');
          var action=button.dataset.delta ? Cart.adjust(button.dataset.key,Number(button.dataset.delta)) : Cart.change(button.dataset.key,Number(button.dataset.qty));
          action.then(function(){if(inDrawer)return self.refresh();window.location.reload();})
            .catch(function(error){var host=inDrawer?self.node:document.querySelector('.cartpage');var el=host&&host.querySelector('[data-cart-error]');if(el)el.textContent=error.message;toast(error.message);})
            .finally(function(){document._mzLineBusy=false;checkoutLock(-1);document.querySelectorAll('[data-line-change]').forEach(function(n){n.disabled=false;});});
        });
      }

      if (!this.node) return;

    },
    refresh: function () {
      var self = this;
      var prevSongs = (function () {
        var n = document.querySelector('[data-cart-songs]');
        return n ? parseInt(n.dataset.songs, 10) || 0 : 0;
      })();
      this._prevSongs = prevSongs;
      return Cart.section().then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('cart-drawer');
        if(!fresh || !self.node)throw new Error('Prekė galėjo būti pridėta. Atidaryk krepšelio puslapį ir patikrink.');
        if (fresh && self.node) {
          var wasOpen = self.node.classList.contains('is-open');
          self.node.innerHTML = fresh.innerHTML;
          checkoutLock(0);
          if (wasOpen) self.node.classList.add('is-open');
          self.bind();
        }
        return Cart.get();
      }).then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });

        /* 34.3: dainų skaičius keičiasi 300 -> 375 per ~550 ms, be triukšmo */
        var songEl = document.querySelector('[data-cart-songs]');
        if (songEl) {
          var to = parseInt(songEl.dataset.songs, 10) || 0;
          var from = self._prevSongs || 0;
          if (to !== from && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            var t0 = performance.now(), dur = 550;
            var step = function (now) {
              var k = Math.min(1, (now - t0) / dur);
              songEl.textContent = Math.round(from + (to - from) * k);
              if (k < 1) requestAnimationFrame(step);
            };
            requestAnimationFrame(step);
          } else {
            songEl.textContent = to;
          }
        }

        /* 34.6: jei pilnas žaidimas pažymėtas „Ką jau turi?", įspėjimo nerodome */
        var warn = document.querySelector('[data-cart-needbase]');
        if (warn) {
          var owned = [];
          try { owned = JSON.parse(localStorage.getItem('mz_owned_products')) || []; } catch (e) {}
          var fulls = ['muzikinis-zaidimas', 'muzikinis-zaidimas-x-agata', 'muzikinis-zaidimas-x-kernagis'];
          var hasFull = fulls.some(function (h) { return owned.indexOf(h) !== -1; });
          warn.hidden = hasFull;
        }
        document.querySelectorAll('[data-cart-total]').forEach(function (n) { n.textContent = money(cart.total_price); });
      });
    },
    open: function () {
      if (!this.node) return;
      this.lastFocus = document.activeElement;
      this.node.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var f = this.node.querySelector('[data-cart-close]');
      if (f) f.focus();
    },
    close: function () {
      if (!this.node) return;
      this.node.classList.remove('is-open');
      document.body.style.overflow = '';
      if (this.lastFocus && this.lastFocus.isConnected) this.lastFocus.focus();
    }
  };

  /* P0-008 — globalus [data-add-variant] klausytojas.
     Veikia bet kur puslapyje, ne tik krepšelio drawer'yje.
     Palaiko kelis ID per kablelį: data-add-variant="123,456" prideda rinkinį. */
  /* Meniu: ESC uždaro, focus grįžta į mygtuką (07 sk.) */
  var menuLastFocus = null;
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) menuLastFocus = e.target.closest('[data-menu-open]');
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.mnav.is-open');
    if (open) {
      open.classList.remove('is-open');
      document.body.style.overflow = '';
      if (menuLastFocus) menuLastFocus.focus();
      return;
    }
    var sub = document.querySelector('.hnav__sub.is-open');
    if (sub) {
      sub.classList.remove('is-open');
      var t = sub.parentElement.querySelector('[data-sub-toggle]');
      if (t) { t.setAttribute('aria-expanded', 'false'); t.focus(); }
    }
  });

  /* V43 §9: senas dovanų klausimynas pašalintas — dovanų režimas dabar
     yra statinis trijų pilnų žaidimų sąrašas, JS jam nereikalingas. */

  /* 46 sk. — dinaminis išsiuntimo pažadas */
  function Dispatch(root) {
    if (root.dataset.enabled !== 'true') return;
    var live = root.querySelector('[data-dispatch-live]');
    if (!live) return;

    var cutoff = parseInt(root.dataset.cutoff, 10) || 14;
    var days = (root.dataset.days || '1,2,3,4,5').split(',')
      .map(function (d) { return parseInt(d, 10); }).filter(Boolean);
    var holidays = (root.dataset.holidays || '').split(',').filter(Boolean);

    function vilnius() {
      // Parduotuvės laiko juosta, ne lankytojo
      var s = new Date().toLocaleString('en-US', { timeZone: 'Europe/Vilnius' });
      return new Date(s);
    }
    function iso(d) {
      return d.getFullYear() + '-' +
        String(d.getMonth() + 1).padStart(2, '0') + '-' +
        String(d.getDate()).padStart(2, '0');
    }
    function isWorking(d) {
      var dow = d.getDay() === 0 ? 7 : d.getDay();
      if (days.indexOf(dow) === -1) return false;
      if (holidays.indexOf(iso(d)) !== -1) return false;
      return true;
    }

    function tick() {
      var now = vilnius();
      if (!isWorking(now) || now.getHours() >= cutoff) {
        live.textContent = CFG.strings.shipNext || '';
        live.hidden = false;
        return;
      }
      var end = new Date(now);
      end.setHours(cutoff, 0, 0, 0);
      var left = Math.floor((end - now) / 1000);
      if (left <= 0) {
        live.textContent = CFG.strings.shipNext || '';
        live.hidden = false;
        return;
      }
      var h = Math.floor(left / 3600);
      var m = Math.floor((left % 3600) / 60);
      var txt = h > 0 ? (h + ' val. ' + m + ' min.') : (m + ' min.');
      live.textContent = (CFG.strings.shipToday || '').replace('{{ time }}', txt);
      live.hidden = false;
    }

    tick();
    var id = setInterval(tick, 30000);
    root._mzStop = function () { clearInterval(id); };
  }

  /* 36 sk. — kartų rekomendavimo slankiklis */
  /* V40 §3: senas AgePicker pašalintas — jį pakeitė game-finder.js. */

  /* V42 §6 — smart sticky header.
     Scroll žemyn: announcement bar susitraukia (grid-template-rows 1fr → 0fr,
     todėl aukštis animuojasi be layout jump). Scroll aukštyn: grįžta iškart.
     Realus sticky aukštis rašomas į --mz-sticky-h, kad anchor'ai
     (scroll-margin-top) niekada neatsidurtų po header'iu. */
  function StickyTop() {
    var bar = document.querySelector('[data-stickytop]');
    if (!bar) return;

    var last = window.pageYOffset;
    var ticking = false;

    function measure() {
      document.documentElement.style.setProperty(
        '--mz-sticky-h', Math.round(bar.getBoundingClientRect().height) + 'px');
    }

    function onScroll() {
      var y = window.pageYOffset;
      var down = y > last && y > 120;
      var up = y < last - 4;
      if (down) bar.classList.add('is-condensed');
      else if (up || y <= 40) bar.classList.remove('is-condensed');
      last = y;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(onScroll);
    }, { passive: true });

    window.addEventListener('resize', measure, { passive: true });
    bar.addEventListener('transitionend', measure);
    measure();
  }
  StickyTop();

  /* B2B prieš / po slankiklis */
  document.addEventListener('input', function (e) {
    var r = e.target.closest('[data-ba-range]');
    if (!r) return;
    var root = r.closest('[data-ba]');
    if (!root) return;
    var v = r.value;
    var after = root.querySelector('[data-ba-after]');
    var handle = root.querySelector('[data-ba-handle]');
    if (after) after.style.clipPath = 'inset(0 0 0 ' + v + '%)';
    if (handle) handle.style.left = v + '%';
  });

  /* Meniu: ESC uždaro, focus grįžta į mygtuką (07 sk.) */
  /* v129: menu keyboard handling is registered once above. */

  /* §5.6 — B2B kortelės CTA: nuslenka iki formos ir užpildo leidimą */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-b2b-pick]');
    if (!b) return;
    e.preventDefault();
    var form = document.querySelector('#uzklausa');
    var sel = document.querySelector('#b2b-edition');
    if (sel) {
      var want = b.dataset.b2bPick;
      [].forEach.call(sel.options, function (o) {
        if (o.text.trim() === want.trim()) sel.value = o.value;
      });
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (form) {
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var first = form.querySelector('input, select, textarea');
      if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 400);
    }
  });

  /* B2B prieš / po slankiklis.
     V67 P0-10: be `input[type=range]` pridėtas tikras tempimas pele ir
     pirštu. `setPointerCapture` leidžia tęsti tempimą net išėjus už
     komponento ribų, `touch-action:none` (CSS) neleidžia puslapiui
     slinkti tempiant pirštu. Klaviatūra ir toliau veikia per range. */
  function CmpSlider(root) {
    var range = root.querySelector('[data-cmp-range]');
    var top = root.querySelector('[data-cmp-top]');
    var line = root.querySelector('[data-cmp-line]');
    if (!range || !top || !line) return;

    function apply() {
      var v = range.value;
      top.style.width = v + '%';
      line.style.left = v + '%';
      range.setAttribute('aria-valuetext', v + '%');
    }

    function fromClientX(x) {
      var r = root.getBoundingClientRect();
      if (!r.width) return;
      var pct = ((x - r.left) / r.width) * 100;
      pct = Math.max(0, Math.min(100, pct));
      range.value = String(Math.round(pct));
      apply();
    }

    range.addEventListener('input', apply);

    var dragging = false;
    root.addEventListener('pointerdown', function (e) {
      dragging = true;
      root.classList.add('is-dragging');
      if (root.setPointerCapture) { try { root.setPointerCapture(e.pointerId); } catch (err) {} }
      fromClientX(e.clientX);
    });
    root.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      e.preventDefault();
      fromClientX(e.clientX);
    });
    function stop(e) {
      if (!dragging) return;
      dragging = false;
      root.classList.remove('is-dragging');
      if (root.releasePointerCapture && e && e.pointerId != null) {
        try { root.releasePointerCapture(e.pointerId); } catch (err) {}
      }
    }
    root.addEventListener('pointerup', stop);
    root.addEventListener('pointercancel', stop);
    root.addEventListener('lostpointercapture', stop);

    apply();
  }

  /* V43 — prekybos vietų žemėlapis.
     Dešinėje pirmiausia matomi tik miestai su vietų kiekiu. Konkretūs adresai
     atsiranda tik išskleidus miestą. Žemėlapio taškas ir miesto blokas yra
     susieti abiem kryptimis: paspaudus tašką atsidaro miestas, pasirinkus
     miestą paryškėja taškas. Vienu metu atviras vienas miestas. */
  function StoreMap(root) {
    var pins = root.querySelectorAll('[data-pin]');
    var cards = root.querySelectorAll('[data-store]');
    var empty = root.querySelector('[data-store-empty]');

    function setOpen(card, on) {
      var btn = card.querySelector('[data-city-toggle]');
      var list = card.querySelector('.citycard__list');
      card.classList.toggle('is-open', on);
      if (btn) btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (list) list.hidden = !on;
    }

    function select(id, scroll) {
      pins.forEach(function (p) { p.classList.toggle('is-active', p.dataset.pin === id); });
      cards.forEach(function (c) {
        var on = c.dataset.store === id;
        c.classList.toggle('is-active', on);
        setOpen(c, on);
      });
      var card = root.querySelector('[data-store="' + id + '"]');
      /* V49 §17: bendras scrollIntoView() pajudindavo visą puslapį — pasirinkus
         miestą žemėlapyje puslapis šokteldavo. Slenkame TIK vidinį miestų
         panelės konteinerį, skaičiuodami poziciją jo koordinačių sistemoje. */
      if (card && scroll) {
        var panel = card.closest('.storemap__list');
        if (panel && panel.scrollHeight > panel.clientHeight) {
          var top = card.offsetTop - panel.offsetTop - 8;
          if (typeof panel.scrollTo === 'function') {
            panel.scrollTo({ top: top, behavior: 'smooth' });
          } else {
            panel.scrollTop = top;
          }
        }
      }
    }

    pins.forEach(function (p) {
      p.addEventListener('click', function () { select(p.dataset.pin, true); });
      p.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(p.dataset.pin, true); }
      });
    });

    cards.forEach(function (c) {
      var btn = c.querySelector('[data-city-toggle]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        /* Pakartotinis paspaudimas ant atviro miesto jį uždaro. */
        if (c.classList.contains('is-open')) {
          setOpen(c, false);
          c.classList.remove('is-active');
          pins.forEach(function (p) { p.classList.remove('is-active'); });
        } else {
          select(c.dataset.store, false);
        }
      });
    });

    // paieškos laukas yra sekcijoje, ne grid'e — ieškome plačiau
    var scope = root.closest('section') || document;
    var search = scope.querySelector('[data-store-search]');
    if (search) {
      search.addEventListener('input', function () {
        var q = search.value.trim().toLowerCase();
        var shown = 0;
        cards.forEach(function (c) {
          var hit = !q || (c.dataset.city || '').indexOf(q) !== -1 || (c.dataset.name || '').indexOf(q) !== -1;
          c.hidden = !hit;
          if (hit) shown++;
          var pin = root.querySelector('[data-pin="' + c.dataset.store + '"]');
          if (pin) pin.style.opacity = hit ? '' : '0.22';

          /* V49 §17: jei aktyvus miestas nebeatitinka filtro, nuimame active
             būseną, uždarome jo adresus ir grąžiname tašką į normalią būseną.
             Kitaip liktų paryškintas, bet paslėptas miestas. */
          if (!hit && c.classList.contains('is-active')) {
            c.classList.remove('is-active');
            setOpen(c, false);
            if (pin) pin.classList.remove('is-active');
          }
        });
        if (empty) empty.hidden = shown !== 0;
      });
    }
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-store-view]');
    if (!b) return;
    var root = b.closest('section');
    if (!root) return;
    root.querySelectorAll('[data-store-view]').forEach(function (n) {
      n.classList.toggle('is-active', n === b);
      n.setAttribute('aria-pressed', n === b ? 'true' : 'false');
    });
    var grid = root.querySelector('[data-store-root]');
    if (!grid) return;

    var isList = b.dataset.storeView === 'list';
    grid.classList.toggle('is-list', isList);

    /* V49 §17: sąrašo režimas anksčiau keitė tik CSS, todėl `hidden` ir
       `aria-expanded` likdavo nesinchronizuoti — ekrano skaitytuvui miestai
       atrodydavo uždaryti, nors vizualiai buvo atidaryti. */
    grid.querySelectorAll('[data-store]').forEach(function (card) {
      var btn = card.querySelector('[data-city-toggle]');
      var list = card.querySelector('.citycard__list');
      if (isList) {
        card.classList.add('is-open');
        if (list) list.hidden = false;
        if (btn) btn.setAttribute('aria-expanded', 'true');
      } else {
        var open = card.classList.contains('is-active');
        card.classList.toggle('is-open', open);
        if (list) list.hidden = !open;
        if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    });
  });

  /* DUK paieška — filtruoja klausimus gyvai.

     V88: pridėtas GLOBALUS režimas. DUK puslapyje paieška yra atskira
     sekcija VIRŠUJE, o klausimai — septyniose kategorijose žemiau.
     Ieškant tik savo sekcijoje toks laukas nefiltruotų nieko.

     `data-faq-scope="global"` -> ieškoma visose puslapio `faq` sekcijose,
     o kategorijos be atitikmenų paslepiamos kartu su antraštėmis.
     Be šio atributo elgsena NEPAKEISTA — sekcijos vidaus paieška veikia
     kaip iki šiol. */
  /* Diakritikų nuėmimas palyginimui. Naudojama ir įvestyje, ir
     turinyje, todėl kryptis nesvarbi. */
  function faqFold(s) {
    return String(s || '').normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '').trim().toLowerCase();
  }

  /* Išvalymo mygtukas: grąžina pilną sąrašą ir fokusą į lauką. */
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-faq-clear]');
    if (!c) return;
    var f = document.querySelector('[data-faq-search]');
    if (!f) return;
    f.value = '';
    f.dispatchEvent(new Event('input', { bubbles: true }));
    f.focus();
  });

  /* Enter paieškos lauke perkelia fokusą į pirmą rastą klausimą.
     Per `input` fokuso nekeičiame — tai nublokštų žmogų nuo klaviatūros
     po kiekvienos raidės. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var f = e.target.closest('[data-faq-search]');
    if (!f) return;
    e.preventDefault();
    var first = [].slice.call(document.querySelectorAll('.faq__item'))
      .filter(function (d) { return !d.hidden; })[0];
    if (!first) return;
    var sm = first.querySelector('summary');
    if (sm) { sm.setAttribute('tabindex', '-1'); sm.focus(); }
  });

  /* Užklausa iš URL — atidarius pasidalintą nuorodą paieška jau
     pritaikyta. */
  document.addEventListener('DOMContentLoaded', function () {
    var f = document.querySelector('[data-faq-search][data-faq-scope="global"]');
    if (!f) return;
    var q = new URLSearchParams(window.location.search).get('duk');
    if (!q) return;
    f.value = q;
    f.dispatchEvent(new Event('input', { bubbles: true }));
  });

  document.addEventListener('input', function (e) {
    var inp = e.target.closest('[data-faq-search]');
    if (!inp) return;

    if (inp.dataset.faqScope === 'global') {
      /* V123 · FAQ-02 — DIAKRITIKAI NEBEGALI SLĖPTI ATSAKYMO.

         Iki šiol lyginta `toLowerCase()` be normalizacijos, todėl
         „ismesti" nerasdavo „išmesti", o „paziurek" — „pažiūrėk".
         Lietuviškoje DUK tai reali kliūtis: žmonės ieško be
         diakritikų dažniau nei su jais.

         `NFD` + combining ženklų pašalinimas veikia abiem kryptimis:
         randama ir įvedus su diakritikais, ir be jų. */
      var gq = faqFold(inp.value);
      var total = 0;
      document.querySelectorAll('.faq__item').forEach(function (d) {
        var hit = !gq || faqFold(d.textContent).indexOf(gq) !== -1;
        d.hidden = !hit;
        if (gq && hit) { d.open = true; total++; }
        if (!gq) d.open = false;
      });
      /* Kategorija be atitikmenų slepiama visa — kitaip liktų kabanti
         antraštė be turinio. */
      document.querySelectorAll('[data-faq-cat]').forEach(function (sec) {
        /* V98: sekcija, kurioje YRA paieškos laukas, niekada
           neslepiama.

           v97 klaida: ieškant be rezultatų paslėpdavau visas
           kategorijas be atitikmenų — įskaitant tą, kurioje stovi pats
           paieškos laukas. Vartotojas likdavo be įvesties lauko ir
           nebegalėdavo paieškos išvalyti.

           Patvirtinta gyvai: `inputMatomas: false` po tuščios
           paieškos. */
        if (sec.contains(inp)) { sec.hidden = false; return; }
        var any = [].slice.call(sec.querySelectorAll('.faq__item')).some(function (d) {
          return !d.hidden;
        });
        sec.hidden = gq ? !any : false;
      });
      var gEmpty = document.querySelector('[data-faq-global-empty]');
      if (gEmpty) gEmpty.hidden = !(gq && total === 0);

      /* Skaitiklis, išvalymo mygtukas ir URL. */
      var cEl = document.querySelector('[data-faq-count]');
      if (cEl) {
        cEl.hidden = !gq;
        /* Žodis ateina iš `data-faq-found` atributo, o ne iš globalaus
           objekto: taip vertimas lieka locale failuose ir neatsiranda
           antro tiesos šaltinio JS'e. */
        if (gq) cEl.textContent = total + ' ' + (cEl.dataset.faqFound || '');
      }
      var clr = document.querySelector('[data-faq-clear]');
      if (clr) clr.hidden = !gq;

      /* V124 · FAQ-02 — PARYŠKINIMAS.

         Paryškinama TIK klausimo antraštėje (`summary`), ne atsakymo
         HTML'e. Atsakymuose yra sąrašai, nuorodos ir `<strong>` —
         teksto mazgų perrašymas ten sulaužytų struktūrą.

         Originalas saugomas `dataset.faqRaw`, todėl išvalius paieškos
         lauką antraštė atstatoma tiksliai tokia, kokia buvo. */
      document.querySelectorAll('.faq__item > summary').forEach(function (sm) {
        if (sm.dataset.faqRaw === undefined) sm.dataset.faqRaw = sm.textContent;
        var raw = sm.dataset.faqRaw;
        if (!gq) { sm.textContent = raw; return; }
        var pos = faqFold(raw).indexOf(gq);
        if (pos === -1) { sm.textContent = raw; return; }
        sm.textContent = '';
        sm.appendChild(document.createTextNode(raw.slice(0, pos)));
        var mk = document.createElement('mark');
        mk.textContent = raw.slice(pos, pos + gq.length);
        sm.appendChild(mk);
        sm.appendChild(document.createTextNode(raw.slice(pos + gq.length)));
      });

      /* URL atspindi paiešką, kad nuorodą būtų galima pasidalinti ir
         kad `back` grąžintų ankstesnę užklausą. `replaceState`, ne
         `pushState` — kitaip kiekviena raidė sukurtų istorijos įrašą. */
      try {
        var u = new URL(window.location.href);
        if (gq) u.searchParams.set('duk', inp.value.trim());
        else u.searchParams.delete('duk');
        window.history.replaceState({}, '', u.toString());
      } catch (err) { /* senos naršyklės — paieška vis tiek veikia */ }
      /* Chip navigacija paieškos metu nebeaktuali. */
      var nav = document.querySelector('.duknav');
      if (nav) nav.closest('section').hidden = !!gq;
      return;
    }

    var scope = inp.closest('section');
    if (!scope) return;
    var q = inp.value.trim().toLowerCase();
    var shown = 0;
    scope.querySelectorAll('details').forEach(function (d) {
      var hit = !q || d.textContent.toLowerCase().indexOf(q) !== -1;
      d.hidden = !hit;
      if (hit) shown++;
      if (q && hit) d.open = true;
      if (!q) d.open = false;
    });
    var empty = scope.querySelector('[data-faq-empty]');
    if (empty) empty.hidden = shown !== 0;
  });

  /* Katalogo kategorijų filtras */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cat-filters] [data-cat]');
    if (!b) return;
    var cat = b.dataset.cat;
    b.parentElement.querySelectorAll('[data-cat]').forEach(function (n) {
      n.classList.toggle('is-active', n === b);
      n.setAttribute('aria-pressed', n === b ? 'true' : 'false');
    });
    document.querySelectorAll('[data-cat-group]').forEach(function (g) {
      g.hidden = !(cat === 'all' || g.dataset.catGroup === cat);
    });
  });

  /* „Jau turiu pilną žaidimą“ — papildymus kelia į viršų, pilnų neslepia */
  document.addEventListener('change', function (e) {
    var t = e.target.closest('[data-owned-toggle]');
    if (!t) return;
    var wrap = t.closest('.wrap');
    if (!wrap) return;
    var exp = wrap.querySelector('[data-cat-group="expansion"]');
    if (!exp) return;
    var parent = exp.parentElement;
    if (t.checked) {
      exp.dataset.moved = '1';
      parent.insertBefore(exp, parent.querySelector('[data-cat-group]'));
    } else if (exp.dataset.moved) {
      var full = parent.querySelector('[data-cat-group="bundle"]');
      if (full) parent.insertBefore(exp, full); else parent.appendChild(exp);
      delete exp.dataset.moved;
    }
  });

  /* P0-010 — dropdown klaviatūrai ir liesenui (hover tvarko CSS) */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-sub-toggle]');
    if (t) {
      var item = t.closest('.hnav__item');
      var sub = item && item.querySelector('[data-sub]');
      if (sub && window.matchMedia('(hover: none)').matches) {
        e.preventDefault();
        var open = sub.classList.toggle('is-open');
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      return;
    }
    document.querySelectorAll('.hnav__sub.is-open').forEach(function (n) {
      if (!n.contains(e.target)) {
        n.classList.remove('is-open');
        var a = n.parentElement.querySelector('[data-sub-toggle]');
        if (a) a.setAttribute('aria-expanded', 'false');
      }
    });
  });

  function purchaseError(button,message){
    var host=button.closest('form,[data-cart-offer],.pcard,.xsell__row,.upsell')||button.parentElement;
    var node=host&&host.querySelector('.mz-form-error');
    if(!node&&host){node=document.createElement('p');node.className='mz-form-error';node.setAttribute('role','alert');host.appendChild(node);}
    if(node)node.textContent=message||'';
    if(message)toast(message);
  }
  var mzCartPending = 0;
  function checkoutLock(delta) {
    mzCartPending = Math.max(0, mzCartPending + delta);
    document.querySelectorAll('button[name="checkout"]').forEach(function (node) {
      if (mzCartPending) { if (!node.hasAttribute('data-mz-checkout-was-disabled')) node.dataset.mzCheckoutWasDisabled = node.disabled ? '1' : '0'; node.disabled = true; }
      else if (node.hasAttribute('data-mz-checkout-was-disabled')) { node.disabled = node.dataset.mzCheckoutWasDisabled === '1'; delete node.dataset.mzCheckoutWasDisabled; }
    });
  }
  document.addEventListener('submit', function (event) {
    if (mzCartPending && event.submitter && event.submitter.name === 'checkout') event.preventDefault();
  }, true);
  function purchase(button,action){
    if(button._mzPurchaseBusy||button.disabled||button.getAttribute('aria-disabled')==='true')return;
    button._mzPurchaseBusy=true;button.disabled=true;button.setAttribute('aria-disabled','true');purchaseError(button,'');
    var added=false; checkoutLock(1);
    action().then(function(){added=true;if(document.querySelector('.cartpage')){window.location.reload();return;}return Drawer.refresh().then(function(){Drawer.open();});})
      .catch(function(error){purchaseError(button,added?'Prekė jau pridėta, bet vaizdo atnaujinti nepavyko. Atidaryk krepšelį; prekės iš naujo nedėk.':error.message);})
      .finally(function(){checkoutLock(-1);button._mzPurchaseBusy=false;button.disabled=false;button.removeAttribute('aria-disabled');});
  }
  document.addEventListener('click',function(e){
    var button=e.target.closest('[data-add-variant]');
    if(button){e.preventDefault();var items=String(button.dataset.addVariant||'').split(',').map(function(v){return Number(v.trim());}).filter(function(v){return Number.isSafeInteger(v)&&v>0;}).map(function(id){return{id:id,quantity:Number(button.dataset.qty)||1};});if(items.length)purchase(button,function(){return Cart.add(items);});return;}
    var upgrade=e.target.closest('[data-upgrade-bundle]');
    if(upgrade){e.preventDefault();purchase(upgrade,function(){return Cart.upgrade(Number(upgrade.dataset.upgradeBundle),String(upgrade.dataset.componentIds||'').split(',').map(Number));});}
  });
  document.addEventListener('submit',function(e){
    var form=e.target.closest('form[data-ajax-cart]');if(!form)return;e.preventDefault();if(!form.reportValidity())return;var button=form.querySelector('[type="submit"]');if(!button)return;var data=new FormData(form);purchase(button,function(){return Cart.addForm(data);});
  });

  /* ---------------- Grotuvas ---------------- */
  function Player(root) {
    var raw = root.querySelector('[data-tracks]');
    var tracks = [];
    if (raw) {
      try {
        var parsed = JSON.parse(raw.textContent);
        if (Array.isArray(parsed)) tracks = parsed;
      } catch (e) {
        if (window.console) console.warn('Grotuvas: netinkamas dainų JSON', e);
      }
    }
    if (!tracks.length) {
      var box = root.querySelector('[data-years]');
      if (box) box.innerHTML = '';
      return;
    }

    var i = Math.floor(Math.random() * tracks.length);
    var audio = root.querySelector('[data-audio]');
    var holder = root.querySelector('[data-frame-holder]');
    var years = root.querySelector('[data-years]');
    var result = root.querySelector('[data-result]');
    var cardImg = root.querySelector('[data-card-image]');
    var meta = root.querySelector('[data-track-meta]');
    var playBtn = root.querySelector('[data-play]');
    var nextBtn = root.querySelector('[data-next]');
    var progress = root.querySelector('[data-progress]');
    var timer = null;

    function stop() {
      root.classList.remove('is-playing');
      if (audio) { audio.pause(); audio.removeAttribute('src'); audio.load(); }
      if (holder) holder.innerHTML = '';
      if (progress) progress.style.right = '100%';
      clearInterval(timer);
      if (playBtn) playBtn.setAttribute('aria-label', root.dataset.playLabel || 'Groti');
    }

    function render() {
      var t = tracks[i];
      stop();
      root.classList.remove('is-answered');
      if (cardImg && t.card) { cardImg.src = t.card; }
      if (meta) meta.textContent = t.index || '';
      if (result) result.textContent = '';
      if (!years) return;
      years.innerHTML = '';
      (t.options || []).forEach(function (y) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = y;
        b.setAttribute('aria-pressed', 'false');
        b.addEventListener('click', function () { guess(b, y, t); });
        years.appendChild(b);
      });
    }

    function guess(btn, year, t) {
      if (root.classList.contains('is-answered')) return;
      root.classList.add('is-answered');
      var right = String(year) === String(t.year);
      btn.setAttribute('aria-pressed', 'true');
      btn.classList.add(right ? 'is-right' : 'is-wrong');
      years.querySelectorAll('button').forEach(function (b) {
        if (b.textContent === String(t.year)) b.classList.add('is-right');
      });
      if (result) {
        result.innerHTML = (right ? '\u2713 ' : '\u2715 ') + '<b>' + t.year + '</b> \u2014 ' +
          esc(t.artist) + ', \u201E' + esc(t.title) + '\u201C. ' + esc(root.dataset.answerNote || '');
      }
      track('player_answer', { correct: right, year: t.year });
    }

    function esc(s) {
      return String(s || '').replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }

    function play() {
      var t = tracks[i];
      if (root.classList.contains('is-playing')) { stop(); return; }
      root.classList.add('is-playing');
      track('player_play', { year: t.year });

      if (t.audio && audio) {
        audio.src = t.audio;
        audio.play().catch(function () { stop(); });
        audio.addEventListener('ended', stop, { once: true });
        timer = setInterval(function () {
          if (audio.duration && progress) {
            progress.style.right = (100 - (audio.currentTime / audio.duration) * 100) + '%';
          }
        }, 250);
        return;
      }
      if (t.youtube && holder) {
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + t.youtube +
          '?autoplay=1&start=' + (t.start || 0) + '&controls=0&modestbranding=1&rel=0&playsinline=1';
        f.title = 'Daina';
        f.allow = 'autoplay; encrypted-media';
        f.width = 1; f.height = 1;
        holder.appendChild(f);
        var started = Date.now();
        timer = setInterval(function () {
          if (!progress) return;
          var pct = Math.min(((Date.now() - started) / 1000) / 210 * 100, 100);
          progress.style.right = (100 - pct) + '%';
        }, 250);
      }
    }

    if (playBtn) playBtn.addEventListener('click', play);
    if (nextBtn) nextBtn.addEventListener('click', function () { i = (i + 1) % tracks.length; render(); });
    render();
  }

  function track(name, params) {
    if (window.dataLayer) window.dataLayer.push(Object.assign({ event: name }, params || {}));
  }

  /* ---------------- Variantai (P0-009) ---------------- */
  function Variants(root) {
    var raw = root.querySelector('[data-variants]');
    if (!raw) return;
    var variants = [];
    try { variants = JSON.parse(raw.textContent) || []; } catch (e) { return; }
    if (variants.length < 2) return;   // vienintelis variantas — nieko sinchronizuoti nereikia

    var selects = root.querySelectorAll('[data-option-index]');
    if (!selects.length) return;

    function apply() {
      var chosen = [];
      selects.forEach(function (sel) { chosen[parseInt(sel.dataset.optionIndex, 10)] = sel.value; });

      var match = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < chosen.length; j++) {
          if (String(v.options[j]) !== String(chosen[j])) { ok = false; break; }
        }
        if (ok) { match = v; break; }
      }
      if (!match) return;

      // hidden id sinchronizuojamas VISOSE formose (pagrindinėje ir sticky)
      document.querySelectorAll('[data-variant-form] input[name="id"]').forEach(function (n) {
        n.value = match.id;
      });

      document.querySelectorAll('[data-price], [data-sticky-buy] .num').forEach(function (node) { node.textContent = money(match.price); });
      document.querySelectorAll('[data-variant-form] [type="submit"]').forEach(function (button) {
        button.disabled = !match.available;
        /* V136 — be kainos: kaina rodoma tiesiai virš mygtuko */
        button.textContent = match.available ? 'Įdėti į krepšelį' : 'Išparduota';
      });
      var stock = document.querySelector('[data-pdp-stock]');
      if (stock) { stock.classList.toggle('is-out', !match.available); stock.replaceChildren(); var dot = document.createElement('i'); stock.appendChild(dot); stock.appendChild(document.createTextNode(match.available ? 'Yra sandėlyje' : 'Išparduota')); }
      root.querySelectorAll('[data-dispatch], .buyrow .qty').forEach(function (node) { node.hidden = !match.available; });
      try { var url = new URL(location.href); url.searchParams.set('variant', match.id); history.replaceState({}, '', url); } catch (_) {}

    }

    selects.forEach(function (sel) { sel.addEventListener('change', apply); });
    apply();
  }

  /* ---------------- Galerija ---------------- */
  function Gallery(root) {
    var main = root.querySelector('[data-gallery-main]');
    root.querySelectorAll('[data-gallery-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        root.querySelectorAll('[data-gallery-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        b.setAttribute('aria-current', 'true');
        if (main) { main.src = b.dataset.full; main.srcset = ''; main.alt = b.dataset.alt || ''; }
      });
    });
  }

  /* ---------------- UGC ---------------- */
  function UGC(root) {
    var rail = root.querySelector('[data-ugc-rail]');
    root.querySelectorAll('[data-ugc-item]').forEach(function (item) {
      item.addEventListener('click', function () {
        var v = item.querySelector('video');
        if (!v) return;
        root.querySelectorAll('video').forEach(function (o) {
          if (o !== v) { o.pause(); o.closest('[data-ugc-item]').classList.remove('is-playing'); }
        });
        if (v.paused) { v.play(); item.classList.add('is-playing'); track('ugc_play'); }
        else { v.pause(); item.classList.remove('is-playing'); }
      });
      var v = item.querySelector('video');
      if (v) v.addEventListener('ended', function () { item.classList.remove('is-playing'); });
    });
    root.querySelectorAll('[data-ugc-nav]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (rail) rail.scrollBy({ left: (b.dataset.ugcNav === 'next' ? 1 : -1) * rail.clientWidth * 0.8, behavior: 'smooth' });
      });
    });
  }

  /* ---------------- Produkto parinkiklis ---------------- */
  /* V40 §31 — sticky ATC:
     rodoma tik kai pagrindinis CTA išėjęs iš viewport, ir paslepiama pasiekus footer,
     kad juosta niekada nebūtų matoma po footer ir nedubliuotų jo turinio. */
  function StickyBuy() {
    var bar = document.querySelector('[data-sticky-buy]');
    var anchor = document.querySelector('[data-sticky-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;

    var past = false;
    var atFooter = false;

    function sync() {
      bar.classList.toggle('is-visible', past && !atFooter);
      bar.classList.toggle('is-hidden', atFooter);
    }

    new IntersectionObserver(function (entries) {
      past = !entries[0].isIntersecting;
      sync();
    }, { rootMargin: '-40px 0px 0px 0px' }).observe(anchor);

    var footer = document.querySelector('.footer') || document.querySelector('footer');
    if (footer) {
      new IntersectionObserver(function (entries) {
        atFooter = entries[0].isIntersecting;
        sync();
      }, { rootMargin: '0px 0px -10px 0px' }).observe(footer);
    }
  }

  /* ---------------- Kiekis ---------------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    input.value = Math.max(1, v + (b.dataset.qty === 'up' ? 1 : -1));
  });

  /* ---------------- „Jau turiu pilną žaidimą" ---------------- */
  function OwnedToggle() {
    var t = document.querySelector('[data-owned-toggle]');
    if (!t) return;
    var saved = false;
    try { saved = localStorage.getItem('mz_owns_base') === '1'; } catch (_) {}
    t.checked = saved;
    apply(saved);
    t.addEventListener('change', function () {
      try { localStorage.setItem('mz_owns_base', t.checked ? '1' : '0'); } catch (_) {}
      apply(t.checked);
    });
    function apply(on) {
      document.body.classList.toggle('owns-base', on);
      document.querySelectorAll('[data-product-type]').forEach(function (card) {
        var isAdd = card.dataset.productType === 'expansion';
        card.style.order = on ? (isAdd ? '-1' : '1') : '0';
      });
      document.querySelectorAll('.needs-base').forEach(function (n) { n.hidden = on; });
    }
  }

  /* ---------------- Mobile nav ---------------- */
  function MobileNav() {
    var nav = document.getElementById('mobile-nav');
    if (!nav) return;
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-menu-open]')) { nav.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
      if (e.target.closest('[data-menu-close]')) { nav.classList.remove('is-open'); document.body.style.overflow = ''; }
    });
  }

  function init(scope) {
    var s = scope || document;
    s.querySelectorAll('[data-player]').forEach(Player);
    s.querySelectorAll('[data-gallery]').forEach(Gallery);
    s.querySelectorAll('[data-variants]').forEach(function (n) { Variants(n.closest('section') || document); });
    s.querySelectorAll('[data-ugc]').forEach(UGC);
    s.querySelectorAll('[data-store-root]').forEach(StoreMap);
    s.querySelectorAll('[data-cmp]').forEach(CmpSlider);
    s.querySelectorAll('[data-dispatch]').forEach(Dispatch);
  }

  document.addEventListener('DOMContentLoaded', function () {
    Drawer.init();
    init(document);
    StickyBuy();
    OwnedToggle();
    MobileNav();
  });

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });


  window.MZ = { Cart: Cart, Drawer: Drawer, toast: toast, money: money };
})();

/* V53.1 — katalogo filtras iš URL (?tipas=papildymai|pilni|riboto).
   Naudoja tą patį mygtuką, kurį spaustų žmogus. */
(function () {
  'use strict';
  function init() {
    var wrap = document.querySelector('[data-cat-filters]');
    if (!wrap) return;
    var map = { papildymai: 'expansion', pilni: 'full', riboto: 'limited', rinkiniai: 'bundle' };
    var t;
    try { t = new URLSearchParams(location.search).get('tipas'); } catch (e) { return; }
    var cat = map[t || ''];
    if (!cat) return;
    var btn = wrap.querySelector('[data-cat="' + cat + '"]');
    if (btn) btn.click();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ==========================================================================
   V69 — PRODUKTO NUOTRAUKŲ GALERIJA

   Trys dalykai vienoje vietoje:
     1. „Peržiūrėti visas" — sekcija išsiplečia TAME PAČIAME puslapyje;
     2. lightbox — full-screen, prev/next, counter, ESC, rodyklės, swipe,
        backdrop close, body scroll lock;
     3. `01 / N` skaitiklis atsinaujina pagal atidarytą kadrą.

   Lightbox markup kuriamas vieną kartą ir dalijamasi tarp visų sekcijų —
   taip pat veikia ir tada, kai puslapyje yra kelios galerijos.
   ========================================================================== */
(function () {
  'use strict';

  var box = null, els = null, items = [], index = 0, lastFocus = null;

  function build() {
    if (box) return;
    box = document.createElement('div');
    box.className = 'pglb';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.hidden = true;
    box.innerHTML =
      '<div class="pglb__bar">' +
        '<span class="pglb__count" data-count></span>' +
        '<button type="button" class="pglb__close" data-close aria-label="Uždaryti">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 5l14 14M19 5L5 19"/></svg>' +
        '</button>' +
      '</div>' +
      '<div class="pglb__stage" data-stage><img class="pglb__img" data-img alt=""></div>' +
      '<div class="pglb__foot">' +
        '<button type="button" class="pglb__nav" data-prev aria-label="Ankstesnė">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 5l-7 7 7 7"/></svg>' +
        '</button>' +
        '<button type="button" class="pglb__nav" data-next aria-label="Kita">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 5l7 7-7 7"/></svg>' +
        '</button>' +
      '</div>';
    document.body.appendChild(box);
    els = {
      img: box.querySelector('[data-img]'),
      count: box.querySelector('[data-count]'),
      stage: box.querySelector('[data-stage]')
    };
    box.querySelector('[data-close]').addEventListener('click', close);
    box.querySelector('[data-prev]').addEventListener('click', function () { go(-1); });
    box.querySelector('[data-next]').addEventListener('click', function () { go(1); });
    /* Paspaudus foną — uždaryti. Paspaudus pačią nuotrauką — ne. */
    box.addEventListener('click', function (e) {
      if (e.target === box || e.target === els.stage) close();
    });
    /* Swipe mobiliajame */
    var x0 = null, y0 = null;
    els.stage.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    els.stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
      x0 = null; y0 = null;
    }, { passive: true });
  }

  function render() {
    var it = items[index]; if (!it) return;
    els.img.src = it.src;
    els.img.alt = it.alt || '';
    els.count.textContent = (index + 1) + ' / ' + items.length;
  }

  function go(step) {
    if (!items.length) return;
    index = (index + step + items.length) % items.length;
    render();
  }

  function onKey(e) {
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowRight') go(1);
    else if (e.key === 'ArrowLeft') go(-1);
  }

  function open(list, i, trigger) {
    build();
    items = list; index = i || 0; lastFocus = trigger || null;
    box.hidden = false;
    box.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onKey);
    render();
    box.querySelector('[data-close]').focus({ preventScroll: true });
  }

  function close() {
    if (!box) return;
    box.classList.remove('is-open');
    box.hidden = true;
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKey);
    if (lastFocus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  function Gallery(root) {
    if (root.dataset.pgalReady) return;
    root.dataset.pgalReady = '1';

    var raw = root.querySelector('[data-pgal-data]');
    var list = [];
    if (raw) { try { list = JSON.parse(raw.textContent); } catch (e) { list = []; } }

    var counter = root.querySelector('.pgal__open .num');

    root.querySelectorAll('[data-pgal-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var i = parseInt(btn.getAttribute('data-pgal-open'), 10) || 0;
        if (counter) counter.textContent = String(i + 1).padStart(2, '0');
        open(list, i, btn);
      });
    });

    var toggle = root.querySelector('[data-pgal-toggle]');
    var rest = root.querySelector('[data-pgal-rest]');
    if (toggle && rest) {
      toggle.addEventListener('click', function () {
        var openNow = rest.hasAttribute('hidden');
        if (openNow) rest.removeAttribute('hidden'); else rest.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', openNow ? 'true' : 'false');
        toggle.textContent = openNow
          ? (toggle.dataset.labelLess || 'Rodyti mažiau')
          : (toggle.dataset.labelMore || 'Peržiūrėti visas');
        if (!openNow) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-pgal]').forEach(Gallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* ==========================================================================
   V71 — INSTAGRAM AUTOMATINIS SRAUTAS

   Tema NIEKADA nekreipia užklausos į instagram.com ir neturi jokio rakto.
   Ji kalbasi tik su mūsų pačių Worker'iu (`data-ig-proxy`), kuris grąžina
   viešą JSON. Raktas gyvena Cloudflare secret'e.

   Elgsena:
     • proxy neuždėtas         → nieko nedaroma, lieka rankinės plytelės;
     • proxy neatsako / klaida → lieka rankinės plytelės, sekcija nesulūžta;
     • proxy atsako            → plytelės pakeičiamos gyvu turiniu.

   Tai reiškia, kad sekcija niekada nerodo tuščio ar sulūžusio feed'o.
   ========================================================================== */
(function () {
  'use strict';

  function tile(item, heading) {
    var a = document.createElement('a');
    a.className = 'igtile';
    a.href = item.permalink;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';

    var img = document.createElement('img');
    img.src = item.image;
    img.alt = (item.caption || heading || '').slice(0, 120);
    img.loading = 'lazy';
    img.decoding = 'async';
    img.width = 700;
    img.height = 700;
    a.appendChild(img);

    var ov = document.createElement('span');
    ov.className = 'igtile__ov';
    ov.setAttribute('aria-hidden', 'true');
    ov.innerHTML =
      '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="1.8">' +
      '<rect x="3" y="3" width="18" height="18" rx="5"/>' +
      '<circle cx="12" cy="12" r="4"/>' +
      '<circle cx="17.4" cy="6.6" r="1.1" fill="currentColor" stroke="none"/></svg>';
    if (item.caption) {
      var cap = document.createElement('span');
      cap.className = 'igtile__cap';
      cap.textContent = item.caption.slice(0, 80);
      ov.appendChild(cap);
    }
    a.appendChild(ov);
    return a;
  }

  function Feed(root) {
    if (root.dataset.igReady) return;
    var proxy = root.getAttribute('data-ig-proxy');
    if (!proxy) return;
    root.dataset.igReady = '1';

    var limit = parseInt(root.getAttribute('data-ig-limit'), 10) || 6;
    var heading = root.getAttribute('data-ig-heading') || '';
    var url = proxy.replace(/\/+$/, '') + '/feed?limit=' + limit;

    var ctrl = null;
    if (typeof AbortController === 'function') {
      ctrl = new AbortController();
      /* Lėtas proxy neturi laikyti puslapio — po 6 s paliekame rankines. */
      setTimeout(function () { ctrl.abort(); }, 6000);
    }

    fetch(url, ctrl ? { signal: ctrl.signal } : undefined)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.ok || !Array.isArray(data.items) || data.items.length === 0) return;
        var frag = document.createDocumentFragment();
        data.items.slice(0, limit).forEach(function (it) { frag.appendChild(tile(it, heading)); });
        root.innerHTML = '';
        root.appendChild(frag);
        root.setAttribute('data-ig-live', data.stale ? 'stale' : 'live');
      })
      .catch(function () { /* Tyliai. Rankinės plytelės lieka vietoje. */ });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-ig-root][data-ig-proxy]').forEach(Feed);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
